/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

// https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/#general-configuration

const awsmobile = {
    "aws_project_region": "us-west-2",
    //"aws_cognito_identity_pool_id": "us-west-2:00e47f02-fcde-4814-ac7b-688300d4202a",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_HqqWhaIZc",
    "aws_user_pools_web_client_id": "1su6gntc2knonm6salj1cqc6tn",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "GIVEN_NAME",
        "FAMILY_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
    ],
    //"cookieStorage": {
    //    expires: 14,
    //    secure: true,
    //}
    // domain: 'gatekeeper.theimperialstrata.com',
    "oauth": {
        domain: 'the-imperial.auth.us-west-2.amazoncognito.com',
        scope: [
            'email',
            'openid',
            'profile'
            //'phone',
            //'aws.cognito.signin.user.admin'
        ],
        redirectSignIn: 'https://theimperialstrata.com/members/booking/auth/sign-in',
        redirectSignOut: 'https://theimperialstrata.com/members/booking/auth/sign-out',
        responseType: 'code'
    }
};


export default awsmobile;
